"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validAddressSchema = exports.addressSubmissionValidation = exports.addressRequired = exports.invalidAddress = void 0;
const yup = __importStar(require("yup"));
const bitcoin_address_validation_1 = __importDefault(require("bitcoin-address-validation"));
// frontend address validation
exports.invalidAddress = "Invalid Bitcoin Address";
exports.addressRequired = "Enter an address...";
// yup.addMethod(yup.type, 'validateAddress', function(address) {
//     return this.test(‘test-name’, "Address failed validation", function(address: string) {
//         const { path, createError } = this;
//         const { some, more, args } = anyArgsYouNeed;
//         // [value] - value of the property being tested
//         // [path]  - property name,
//         // ...
//         return someCondition || conditionTwo || createError(...);
//     });
// });
exports.addressSubmissionValidation = yup
    .string()
    .max(255, exports.invalidAddress)
    .required(exports.addressRequired)
    .min(23, exports.invalidAddress)
    .test("Address Test", "Address failed validation", 
// @ts-ignore
function (address) {
    if (!address) {
        return false;
    }
    else if ((0, bitcoin_address_validation_1.default)(address)) {
        return true;
    }
    else if (address.length > 0 && address.substring(0, 2) === "ln") {
        return true;
    }
    {
        return false;
    }
});
exports.validAddressSchema = yup.object().shape({
    address: exports.addressSubmissionValidation,
});
//# sourceMappingURL=address.js.map